module.exports = __webpack_public_path__ + "img/forestcare_nizke.c77a8821.png";